import React from "react";
import Image from "@atlaskit/image";
import light from "../../assets/errorSearchNoResult/light.svg";
import dark from "../../assets/errorSearchNoResult/dark.svg";

const ErrorSearchNoResultIllustration = (): React.JSX.Element => (
  <div style={{ width: "275px", height: "275px" }}>
    <Image alt="Error" src={light} srcDark={dark} />
  </div>
);

export default ErrorSearchNoResultIllustration;
